export var THDFormControlStyles = {};
